import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authReducer } from 'features/auth/authSlice';
import { navigationReducer } from 'features/navbar/navigationSlice';
import { cobrandReducer } from 'features/cobrand/cobrandSlice';
import { surveyReducer } from 'features/checklist/surveySlice';
import { useDispatch } from 'react-redux';
import { authService } from 'services/authService';
import { setupListeners } from '@reduxjs/toolkit/query';
import { chatReducer } from 'features/chat/chatSlice';
import { signUpReducer } from 'features/signUp/signUpSlice';
import { assessmentsAuthReducer } from 'features/assessments/assessmentsAuthSlice';
import { assessmentsReducer } from 'features/assessments/assessmentsSlice';
import { assessmentsService } from 'services/assessmentsService';

const rootReducer = combineReducers({
  auth: authReducer,
  navigation: navigationReducer,
  cobrand: cobrandReducer,
  survey: surveyReducer,
  chat: chatReducer,
  signUp: signUpReducer,
  assessmentsAuth: assessmentsAuthReducer,
  assessments: assessmentsReducer,
  [authService.reducerPath]: authService.reducer,
  [assessmentsService.reducerPath]: assessmentsService.reducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(authService.middleware, assessmentsService.middleware),
  });

export const store = setupStore();
setupListeners(store.dispatch);
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>(); // Export a hook that can be reused to resolve types
